(function() {
  function fetchAndUpdateProduct(handle) {
    const jsonUrl = `/products/${handle}.json`;
    fetch(jsonUrl)
      .then(r => {
        if (!r.ok) throw new Error("Failed to fetch product JSON");
        return r.json();
      })
      .then(data => {
        if (!data.product || !data.product.id) throw new Error("No product ID found");
        const productId = data.product.id;

        if (window.__st) {
          window.__st.rid = productId;
          window.__st.pageurl = window.location.href;
        }

        if (typeof videowiseBulkTrigger === 'function' && typeof initVideowise === 'function') {
          try {
            setTimeout(() => {
              window.videowiseIdsLoaded = [];
              window.videowiseBulkTrigger();
            }, 500);
          } catch (err) {
            console.error('❌ Error calling Videowise functions:', err);
          }
        }
      })
      .catch(err => console.error(err));
  }

  const pushState = history.pushState;
  history.pushState = function() {
    pushState.apply(history, arguments);
    handleUrlChange();
  };
  const replaceState = history.replaceState;
  history.replaceState = function() {
    replaceState.apply(history, arguments);
    handleUrlChange();
  };
  window.addEventListener("popstate", handleUrlChange);

  function handleUrlChange() {
    const handle = window.location.pathname.split("/").pop();
    if (handle) fetchAndUpdateProduct(handle);
  }

  handleUrlChange();
})();
